import { _ as __assign, a as __rest, b as __spreadArrays, c as __makeTemplateObject } from '../tslib.es6-896f83a9.js';
import React__default, { useState, useRef, useEffect, Suspense, Fragment } from 'react';
import { F as Flexbox, I as IconButton, f as faAngleUp, a as faAngleRight, H as Heading, T as Text, D as Divider, P as Popover, u as useStylesInputField, c as colors, C as ColorItem, b as ColorPicker, d as PortalContext, M as MenuList, e as MenuListItem, g as Input, h as FormSection, i as Table, j as TableHeader, k as TableCell, B as Button, S as Sheet, l as SheetContent, m as Skeleton, n as useViewport, o as SheetFooter, p as PopoverFooter, q as SheetHeader, r as PopoverHeader, s as DatePicker, t as TimeInput, v as Drawer, w as DrawerContent, R as ReadViewContainer, x as InlineEdit, y as DateTimeInput, z as Card, A as CardContent, E as Placeholder, G as CardFooter, J as CardHeader, K as H5, L as Modal, N as ModalContent, O as ModalHeader, Q as ModalFooter, U as usePermissions, V as useDebounce, W as Icon, X as Notification, Y as ToastContext, Z as ToastContainer, _ as Tooltip, $ as faExclamationCircle, a0 as faCaretUp, a1 as faCaretDown } from '../Wizard-9d01e97c.js';
export { a3 as APP_STATE_COOKIE_NAME, a2 as App, a4 as AppContext, a5 as AppContextProvider, a6 as Avatar, a7 as AvatarSkeleton, a8 as Badge, a9 as BasicPage, aa as BasicPageHeader, ab as Box, ad as Breadcrumb, ac as Breadcrumbs, B as Button, z as Card, A as CardContent, G as CardFooter, J as CardHeader, af as Chip, ae as ChipContainer, ag as Collapse, C as ColorItem, b as ColorPicker, ao as ComboDatePicker, aj as Confirm, am as DateInput, s as DatePicker, y as DateTimeInput, D as Divider, v as Drawer, w as DrawerContent, ar as DrawerHeader, aw as DropZone, as as ErrorBox, at as Field, au as FieldList, av as Fieldset, ax as FileItem, ay as FileList, F as Flexbox, az as FormFooter, h as FormSection, aA as Grid, aB as H1, aC as H2, aD as H3, aE as H4, K as H5, aF as H6, H as Heading, W as Icon, I as IconButton, aI as InlineDateInput, x as InlineEdit, aH as InlineInputField, aJ as InlineMultiSelect, aK as InlineSelect, aG as InlineTextArea, aL as InlineTimeOffsetInput, g as Input, an as IntervalInput, ap as IntervalPicker, aO as Label, aP as LightBox, aQ as Logo, aR as MarkdownContent, M as MenuList, e as MenuListItem, L as Modal, N as ModalContent, Q as ModalFooter, O as ModalHeader, ak as MonthInput, al as MonthPicker, aS as MultiSelect, aq as NewDateTimeInput, aM as NewInlineDateTimeInput, aN as NewInlineSelect, aT as NoAccessPanel, X as Notification, aU as Overlay, E as Placeholder, P as Popover, aV as PopoverContent, p as PopoverFooter, r as PopoverHeader, aW as PopoverToSheet, aX as PopoverToSheetContent, aY as Portal, d as PortalContext, aZ as RadioButton, R as ReadViewContainer, a_ as SearchSelect, a$ as SearchSelectOption, b0 as Select, b2 as Select2, b3 as Select2Dropdown, b1 as SelectDropdown, S as Sheet, l as SheetContent, o as SheetFooter, q as SheetHeader, b5 as SidebarLayout, b4 as SidebarMenuItem, b6 as SidebarNavigation, b7 as SidebarNavigationLink, m as Skeleton, b8 as SortableList, b9 as SortableListItem, ba as StatusIndicator, bb as Switch, bd as Tab, i as Table, k as TableCell, bc as TableFilters, j as TableHeader, be as Tabs, T as Text, bf as TextSkeleton, bg as Textarea, t as TimeInput, bi as TimeOffsetInput, bh as TimePicker, bk as ToggleButtonGroup, _ as Tooltip, bl as VisibleContainer, bm as VisuallyHidden, bn as Wizard, bo as WizardStep, c as colors, ah as getColor, ai as getColorFromHex, bj as useStyles, u as useStylesInputField } from '../Wizard-9d01e97c.js';
import { g as faTimes, h as faEllipsisH, i as faCopy, j as faSpinner } from '../index.es-840d4524.js';
import { T as Timer, c as createRandomId } from '../Timer-c078a2ef.js';
import '../accessTokens-74425a4a.js';
import { Editor } from '@toast-ui/react-editor';
import { useResolvedPath, useLocation, NavLink } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { ThemeProvider as ThemeProvider$1 } from 'react-jss';
import { f as format, l as locale } from '../millisecondsToDateParts-8e4a9313.js';
import { s as sonikaTheme } from '../sonikaTheme-c58de996.js';
import { p as pluralize } from '../pluralize-909fde53.js';
import '../supportsCSSPropertyValue-b6b8cdb3.js';
import '../uploadFile-6fa21335.js';
import '../filterDistinct-c0340793.js';
import '../backgroundColors-77340375.js';
import 'path';
import 'js-cookie';

var AccordionItem = function (props) {
    var actions = props.actions, children = props.children, _a = props.defaultOpen, defaultOpen = _a === void 0 ? false : _a, size = props.size, title = props.title, subText = props.subText, _b = props.padding, padding = _b === void 0 ? 'none' : _b;
    var _c = useState(defaultOpen), rowOpen = _c[0], setRowOpen = _c[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { onClick: function () { return setRowOpen(!rowOpen); }, onKeyDown: function (event) {
                if (event.keyCode === 13) {
                    setRowOpen(!rowOpen);
                }
            }, tabIndex: 0, role: "button", "aria-pressed": "false" },
            React__default.createElement(Flexbox, { justify: "space", align: "center" },
                React__default.createElement("div", { onClick: function () { return setRowOpen(!rowOpen); }, role: "button", style: { cursor: 'pointer' } },
                    React__default.createElement(Flexbox, { align: "center", style: { padding: padding === 'none' ? undefined : '4px 0' } },
                        React__default.createElement(IconButton, { appearance: "text", color: rowOpen ? 'primary' : 'dark', icon: rowOpen ? faAngleUp : faAngleRight, size: size === 'large' ? 'large' : 'medium' }),
                        React__default.createElement(Flexbox, { direction: "column" },
                            typeof title === 'string' ? (React__default.createElement(Heading, { appearance: size === 'large' ? 'h3' : 'h4' }, title)) : title,
                            (subText && (React__default.createElement(Text, __assign({}, subText))))))),
                !!actions && (React__default.createElement("div", { onClick: function (event) { return event.stopPropagation(); }, onKeyDown: function (event) { return event.stopPropagation(); } }, actions)))),
        rowOpen && React__default.createElement("div", null, children)));
};

var Accordion = function (props) {
    var children = props.children;
    return (React__default.createElement(Flexbox, { direction: "column" }, React__default.Children.map(children, function (child, index) { return (React__default.createElement(React__default.Fragment, null,
        child,
        (index < React__default.Children.count(children) - 1) && React__default.createElement(Divider, null))); })));
};

var PopoverLink = function (props) {
    var children = props.children, popover = props.popover, _a = props.trigger, trigger = _a === void 0 ? 'hover' : _a, rest = __rest(props, ["children", "popover", "trigger"]);
    var anchor = useRef(null);
    var _b = useState(false), popoverVisible = _b[0], setPopoverVisible = _b[1];
    var _c = useState(null), timerId = _c[0], setTimerId = _c[1];
    var handleClick = function () {
        setPopoverVisible(true);
    };
    var handleMouseOver = function () {
        if (timerId) {
            clearTimeout(timerId);
            setTimerId(null);
        }
        setPopoverVisible(true);
    };
    var handleMouseOut = function () {
        var timerId = setTimeout(function () { return setPopoverVisible(false); }, 100);
        setTimerId(timerId);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { onClick: trigger === 'click' ? handleClick : null, onMouseOver: trigger === 'hover' ? handleMouseOver : null, onMouseOut: trigger === 'hover' ? handleMouseOut : null, ref: anchor, style: { position: 'relative' } }, children),
        React__default.createElement(Popover, __assign({ anchorEl: popoverVisible ? anchor.current : null, onClose: function () {
                if (trigger === 'click') {
                    setPopoverVisible(false);
                }
            }, onMouseOut: trigger === 'hover' ? handleMouseOut : null, onMouseOver: trigger === 'hover' ? handleMouseOver : null }, rest), popover)));
};

var Checkbox = function (props) {
    props.className; var defaultChecked = props.defaultChecked, disabled = props.disabled; props.error; var inputId = props.inputId, inputName = props.inputName, inputRef = props.inputRef; props.style; var rest = __rest(props, ["className", "defaultChecked", "disabled", "error", "inputId", "inputName", "inputRef", "style"]);
    return (React__default.createElement("input", __assign({ defaultChecked: defaultChecked, disabled: disabled, id: inputId, name: inputName, ref: inputRef, style: {}, type: "checkbox" }, rest)));
};

var ColorInput = function (props) {
    var defaultValue = props.defaultValue, placeholder = props.placeholder, onChange = props.onChange, error = props.error, disabled = props.disabled, inputRef = props.inputRef, inputName = props.inputName;
    var classes = useStylesInputField({ display: 'block', disabled: disabled, error: error });
    var _a = useState(defaultValue ? colors === null || colors === void 0 ? void 0 : colors.find(function (color) { return (color === null || color === void 0 ? void 0 : color.name) === defaultValue || color.hex === defaultValue; }) : undefined), value = _a[0], setValue = _a[1];
    var _b = useState(false), popoverOpen = _b[0], setPopoverOpen = _b[1];
    var readViewRef = useRef();
    return (React__default.createElement("div", { className: classes.root },
        inputRef && inputName && React__default.createElement("input", { type: "hidden", ref: inputRef, name: inputName, value: value === null || value === void 0 ? void 0 : value.hex }),
        React__default.createElement("div", { ref: readViewRef, onClick: function () { return setPopoverOpen(true); }, className: classes.inputField, style: { lineHeight: '1.25rem' } },
            React__default.createElement(Flexbox, { align: "center" },
                value ? React__default.createElement(ColorItem, { color: value, placeholder: placeholder }) : React__default.createElement("div", null, "\u00A0"),
                React__default.createElement(IconButton, { id: "clear-button", icon: faTimes, appearance: "text", color: "default", style: {
                        position: 'absolute',
                        right: 0,
                    }, onClick: function () {
                        setValue(undefined);
                        if (onChange)
                            onChange(undefined);
                    } }))),
        React__default.createElement(Popover, { anchorEl: popoverOpen ? readViewRef.current : null, placement: "bottom-start", onClose: function () {
                setPopoverOpen(false);
            } },
            React__default.createElement("div", { style: { minWidth: 240 } },
                React__default.createElement("div", { style: { display: 'flex', flexDirection: 'column', padding: 12 } },
                    React__default.createElement("small", null, "V\u00E4lj f\u00E4rg")),
                React__default.createElement(Divider, null),
                React__default.createElement("div", { style: { padding: 2, overflowY: 'auto', maxHeight: 234 } },
                    React__default.createElement(ColorPicker, { setSelectedColor: function (color) {
                            setPopoverOpen(false);
                            setValue(color);
                            if (!!onChange)
                                onChange(color === null || color === void 0 ? void 0 : color.hex);
                        } }))))));
};

var PortalProvider = function (props) {
    var children = props.children;
    var portalRef = useRef();
    var _a = useState(), context = _a[0], setContext = _a[1];
    useEffect(function () {
        setContext(portalRef.current);
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(PortalContext.Provider, { value: context }, children),
        React__default.createElement("div", { ref: portalRef, style: {
                position: 'relative',
                zIndex: 1000,
            } })));
};

var ContextMenu = function (props) {
    var children = props.children, disabled = props.disabled, _a = props.size, size = _a === void 0 ? 'small' : _a, _b = props.appearance, appearance = _b === void 0 ? 'outlined' : _b, _c = props.color, color = _c === void 0 ? 'primary' : _c, preText = props.preText, postText = props.postText, _d = props.icon, icon = _d === void 0 ? faEllipsisH : _d;
    var iconButtonRef = useRef();
    var _e = useState(false), showPopover = _e[0], setShowPopover = _e[1];
    return (React__default.createElement("span", null,
        React__default.createElement(IconButton, { disabled: disabled, icon: icon, size: size, onClick: function () { return setShowPopover(true); }, ref: iconButtonRef, appearance: appearance, color: color, preText: preText, postText: postText }),
        React__default.createElement("span", { onClick: function () { return setShowPopover(false); } },
            React__default.createElement(Popover, { anchorEl: showPopover ? iconButtonRef.current : null, onClose: function () { return setShowPopover(false); } },
                React__default.createElement(MenuList, null, children)))));
};

var ContextMenuItem = function (props) {
    return React__default.createElement(MenuListItem, __assign({}, props));
};

var CopyableText = function (props) {
    var className = props.className, disabled = props.disabled, onCopy = props.onCopy, onError = props.onError, style = props.style, value = props.value;
    var inputRef = useRef(null);
    var copyToClipboard = function (ref) {
        navigator.clipboard
            .writeText(value)
            .then(function () {
            onCopy();
        })
            .catch(function () {
            onError();
        });
    };
    return (React__default.createElement(Flexbox, { className: className, gap: "xsmall", style: style },
        React__default.createElement("div", { style: { flex: 1 } },
            React__default.createElement(Input, { disabled: true, display: "block", inputRef: inputRef, value: value })),
        React__default.createElement(IconButton, { disabled: disabled || !navigator.clipboard, icon: faCopy, onClick: function () { return copyToClipboard(); } })));
};

var TableBody = function (props) {
    var children = props.children;
    return (React__default.createElement("tbody", null, children));
};

var TableHead = function (props) {
    var children = props.children;
    return (React__default.createElement("thead", null, children));
};

var TableRow = function (props) {
    var children = props.children;
    return (React__default.createElement("tr", null, children));
};

var Form = function (props) {
    var children = props.children, className = props.className, columns = props.columns, _a = props.gap, gap = _a === void 0 ? 'medium' : _a, onChange = props.onChange, onSubmit = props.onSubmit, rest = __rest(props, ["children", "className", "columns", "gap", "onChange", "onSubmit"]);
    return (React__default.createElement("form", __assign({ className: [className].join(' '), onChange: onChange, onSubmit: onSubmit }, rest),
        React__default.createElement(FormSection, { columns: columns, gap: gap }, children)));
};

var DataTable = function (_a) {
    var columns = _a.columns, rows = _a.rows, sorting = _a.sorting, onSort = _a.onSort, pagination = _a.pagination, onPaginate = _a.onPaginate, loading = _a.loading, className = _a.className;
    var cols = Object.keys(columns).map(function (key) { return ({
        column: columns[key],
        key: key,
    }); });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Table, { className: className },
            React__default.createElement(TableHead, null,
                React__default.createElement(TableRow, null, cols &&
                    cols.map(function (_a) {
                        var column = _a.column, key = _a.key;
                        if (!column) {
                            return;
                        }
                        var align = column.align, sortable = column.sortable, text = column.text, width = column.width;
                        (sorting === null || sorting === void 0 ? void 0 : sorting.column) === key;
                        var sortingDirection = (sorting === null || sorting === void 0 ? void 0 : sorting.column) === key && (sorting === null || sorting === void 0 ? void 0 : sorting.direction) === 'ASC' ? 'DESC' : 'ASC';
                        return (React__default.createElement(TableHeader, { align: align, key: key, onClick: function () {
                                if (sortable && !loading) {
                                    onSort(key, sortingDirection);
                                }
                            }, width: width }, text));
                    }))),
            React__default.createElement(TableBody, null, rows &&
                rows.map(function (row, rowIndex) { return (React__default.createElement(TableRow, { key: rowIndex }, cols.map(function (_a) {
                    var column = _a.column, key = _a.key;
                    if (!column) {
                        return;
                    }
                    var align = column.align, render = column.render;
                    var cell = row[key];
                    return (React__default.createElement(TableCell, { align: align, key: key }, render ? render(cell, row) : cell && cell.toString()));
                }))); }))),
        pagination && pagination.hasNextPage && (React__default.createElement("div", null,
            React__default.createElement(Button, { onClick: function () { return onPaginate(); }, disabled: loading }, pagination.buttonText)))));
};

var SheetSkeleton = function (props) {
    var onClose = props.onClose, type = props.type, _a = props.height, height = _a === void 0 ? '40vh' : _a;
    return (React__default.createElement(Sheet, { onClose: onClose },
        React__default.createElement(SheetContent, null,
            React__default.createElement(Skeleton, { height: height, type: type }))));
};

var PopoverToSheetFooter = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetFooter, __assign({}, props)));
    }
    return (React__default.createElement(PopoverFooter, __assign({}, props)));
};

var PopoverToSheetHeader = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetHeader, __assign({}, props)));
    }
    return (React__default.createElement(PopoverHeader, __assign({}, props)));
};

var PopoverToSheetSkeleton = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetSkeleton, __assign({}, props)));
    }
    return null;
};

var DateTimePicker = function (props) {
    var defaultValue = props.defaultValue, onChange = props.onChange, minDate = props.minDate, maxDate = props.maxDate;
    var media = useViewport().size;
    return (React__default.createElement(Flexbox, { align: "center", direction: media === 'small' ? 'column' : 'row', gap: media === 'large' ? 'medium' : undefined, style: { height: '100%' } },
        React__default.createElement("div", null,
            React__default.createElement(DatePicker, { selectedDate: defaultValue || new Date(), minDate: minDate, maxDate: maxDate, onChange: function (dateValue) {
                    if (defaultValue) {
                        onChange(new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.getHours(), defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.getMinutes(), defaultValue.getSeconds()));
                    }
                    else {
                        onChange(dateValue);
                    }
                } })),
        React__default.createElement(Flexbox, { gap: "xsmall", direction: media === 'small' ? 'row' : 'column', align: media === 'small' ? 'center' : 'start', justify: media === 'small' ? 'equal' : 'space', style: { flex: 1 } },
            React__default.createElement(Text, null, "Klockslag:"),
            React__default.createElement(TimeInput, { value: defaultValue, onChange: function (time) {
                    var date = defaultValue !== null && defaultValue !== void 0 ? defaultValue : new Date();
                    onChange(new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()));
                } }))));
};

var DrawerSkeleton = function (props) {
    var onClose = props.onClose, type = props.type;
    return (React__default.createElement(Drawer, { onClose: onClose, open: true },
        React__default.createElement(DrawerContent, { style: { display: 'flex', flex: 1 } },
            React__default.createElement(Skeleton, { type: type }))));
};

var FormModal = function (props) {
    var children = props.children, disabled = props.disabled, onClose = props.onClose, onSubmit = props.onSubmit, _a = props.size, size = _a === void 0 ? 'medium' : _a, _b = props.submitButtonLabel, submitButtonLabel = _b === void 0 ? 'Skicka' : _b, _c = props.title, title = _c === void 0 ? 'Formulär' : _c;
    return (React__default.createElement(ModalToSheet, { onClose: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); }, size: size },
        React__default.createElement(ModalToSheetHeader, { onClose: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); } }, title),
        React__default.createElement(ModalToSheetContent, null, children),
        React__default.createElement(ModalToSheetFooter, null,
            React__default.createElement(Flexbox, { justify: "end" },
                React__default.createElement(Button, { disabled: disabled, onClick: function () { return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(); } }, submitButtonLabel)))));
};

var InlineColorSelect = function (props) {
    var defaultValue = props.defaultValue, placeholder = props.placeholder, onChange = props.onChange, error = props.error, disabled = props.disabled;
    var readViewRef = useRef();
    var readView = (React__default.createElement(ReadViewContainer, null,
        React__default.createElement(ColorItem, { color: defaultValue, placeholder: placeholder })));
    return (React__default.createElement("div", null,
        React__default.createElement("div", { ref: readViewRef }),
        React__default.createElement(InlineEdit, { disabled: disabled, startWithEditViewOpen: !!error, onChange: function (event) {
                onChange(event);
            }, view: function () { return readView; }, edit: function (setEditViewOpen) { return (React__default.createElement(React__default.Fragment, null,
                readView,
                React__default.createElement(Popover, { anchorEl: readViewRef.current, placement: "bottom-start", onClose: function () {
                        setEditViewOpen(false);
                    } },
                    React__default.createElement("div", { style: { minWidth: 240 } },
                        React__default.createElement("div", { style: { display: 'flex', flexDirection: 'column', padding: 12 } },
                            React__default.createElement("small", null, "V\u00E4lj f\u00E4rg")),
                        React__default.createElement(Divider, null),
                        React__default.createElement("div", { style: { padding: 2, overflowY: 'auto', maxHeight: 234 } },
                            React__default.createElement(ColorPicker, { setSelectedColor: function (color) {
                                    setEditViewOpen(false);
                                    onChange(color);
                                } })))))); } })));
};

var InlineDateTimeInput = function (props) {
    var defaultValue = props.defaultValue, onChange = props.onChange, error = props.error, _a = props.dateFormat, dateFormat = _a === void 0 ? 'yyyy-MM-dd HH:mm' : _a, disabled = props.disabled, view = props.view, inputName = props.inputName, inputRef = props.inputRef;
    return (React__default.createElement(InlineEdit, { disabled: disabled, displayActionButtons: true, startWithEditViewOpen: !!error, onChange: function (event) {
            onChange(event);
        }, view: function (setEditViewOpen) { return (React__default.createElement(ReadViewContainer, { disabled: disabled }, !!view ? (view(setEditViewOpen, format(new Date(defaultValue), dateFormat, { locale: locale }))) : (React__default.createElement("div", null, format(new Date(defaultValue), dateFormat, { locale: locale }))))); }, edit: function (setEditViewOpen) { return (React__default.createElement(DateTimeInput, { defaultValue: defaultValue, inputName: inputName, inputRef: inputRef })); } }));
};

var KeyValue = function (props) {
    var children = props.children, label = props.label, value = props.value, _a = props.direction, direction = _a === void 0 ? 'column' : _a; props.labelAppearance; var _c = props.labelBold, labelBold = _c === void 0 ? false : _c;
    var gap = direction == 'column' ? 'xxsmall' : 'medium';
    return (React__default.createElement(Flexbox, { direction: direction, gap: gap },
        React__default.createElement(Text, { bold: labelBold, appearance: "light" }, label),
        children ? React__default.createElement("div", null, children) : value ? React__default.createElement(Text, null, value) : React__default.createElement(Text, null, "-")));
};

var ListBox = function (props) {
    var children = props.children;
    return (React__default.createElement(Card, { borders: true, shadow: "none", style: { display: 'flex', flex: 1, flexDirection: 'column' } }, children));
};

var ListBoxBody = function (props) {
    var children = props.children;
    return (React__default.createElement(Suspense, { fallback: React__default.createElement(Skeleton, { style: { flex: 1, margin: '0.5rem' }, type: "table" }) },
        React__default.createElement(CardContent, { style: {
                flex: 1,
                overflowY: 'auto',
            } },
            React__default.createElement(Flexbox, { direction: "column", gap: "small", style: { height: '100%' } }, children))));
};

var ListBoxEmptyState = function (props) {
    var text = props.text;
    return React__default.createElement(Placeholder, { height: "full", text: text });
};

var ListBoxFooter = function (props) {
    var children = props.children;
    return (React__default.createElement(CardFooter, null,
        React__default.createElement(Flexbox, { direction: "column", gap: "small" }, children)));
};

var ListBoxHeader = function (props) {
    var children = props.children, title = props.title;
    return (React__default.createElement(CardHeader, null,
        React__default.createElement(Flexbox, { direction: "column", gap: "small" },
            React__default.createElement(H5, null, title),
            children)));
};

var ListBoxItem = function (props) {
    var actions = props.actions, children = props.children;
    return (React__default.createElement(Flexbox, { justify: "space" },
        typeof children === 'string' ? React__default.createElement(Text, null, children) : children,
        actions && React__default.createElement(Flexbox, { gap: "xsmall" }, actions)));
};

var ListBoxSearch = function (props) {
    var onSearch = props.onSearch, placeholder = props.placeholder;
    return React__default.createElement(Input, { onChange: function (value) { return onSearch === null || onSearch === void 0 ? void 0 : onSearch(value); }, placeholder: placeholder });
};

var MarkdownEditor = function (props) {
    var _a = props.height, height = _a === void 0 ? '400px' : _a, initialValue = props.initialValue, onBlur = props.onBlur, onChange = props.onChange, _b = props.toolbarItems, toolbarItems = _b === void 0 ? [
        ['bold', 'italic'],
        ['ul', 'ol'],
        ['link', 'image'],
    ] : _b;
    var editorRef = useRef(null);
    return (React__default.createElement(Editor, { height: height, initialEditType: "wysiwyg", initialValue: initialValue !== null && initialValue !== void 0 ? initialValue : '', onBlur: function () { return onBlur === null || onBlur === void 0 ? void 0 : onBlur(); }, onChange: function () {
            onChange === null || onChange === void 0 ? void 0 : onChange(editorRef.current.editorInst.getMarkdown());
        }, ref: editorRef, usageStatistics: false, toolbarItems: toolbarItems }));
};

var Menu = function (props) {
    var children = props.children;
    return (React__default.createElement(Flexbox, { direction: "row", gap: "medium", style: { borderBottom: sonikaTheme.helpers.pxToRem(1) + " solid " + sonikaTheme.colors.divider } }, children));
};

var MenuItem = function (props) {
    var index = props.index, path = props.path, text = props.text;
    var resolvedPath = useResolvedPath(path);
    var pathname = useLocation().pathname;
    return (React__default.createElement(NavLink, { to: path, style: {
            borderBottom: (index && resolvedPath.pathname === pathname) || (!index && pathname.indexOf(resolvedPath.pathname) === 0)
                ? sonikaTheme.helpers.pxToRem(3) + " solid " + sonikaTheme.colors.primary
                : undefined,
            color: sonikaTheme.colors.foreground.secondary,
            display: 'inline-block',
            padding: '0.5rem 0',
        } }, text));
};

var ModalSkeleton = function (props) {
    var onClose = props.onClose, type = props.type, _a = props.height, height = _a === void 0 ? '40vh' : _a;
    return (React__default.createElement(Modal, { onClose: onClose },
        React__default.createElement(ModalContent, null,
            React__default.createElement(Skeleton, { height: height, type: type }))));
};

var ModalToSheet = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(Sheet, __assign({}, props)));
    }
    return (React__default.createElement(Modal, __assign({}, props)));
};

var ModalToSheetHeader = function (props) {
    var closeButtonLabel = props.closeButtonLabel, rest = __rest(props, ["closeButtonLabel"]);
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetHeader, __assign({}, rest, { closeButtonLabel: closeButtonLabel })));
    }
    return (React__default.createElement(ModalHeader, __assign({}, rest)));
};

var ModalToSheetFooter = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetFooter, __assign({}, props)));
    }
    return (React__default.createElement(ModalFooter, __assign({}, props)));
};

var ModalToSheetContent = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetContent, __assign({}, props)));
    }
    return (React__default.createElement(ModalContent, __assign({}, props)));
};

var ModalToSheetSkeleton = function (props) {
    var pageSize = useViewport().size;
    if (pageSize === 'small') {
        return (React__default.createElement(SheetSkeleton, __assign({}, props)));
    }
    return (React__default.createElement(ModalSkeleton, __assign({}, props)));
};

var Panel = function (props) {
    var actions = props.actions, children = props.children, maxHeight = props.maxHeight, title = props.title;
    return (React__default.createElement(Card, { shadow: "small", style: { display: 'flex', flexDirection: 'column' } },
        title && (React__default.createElement(CardHeader, null,
            React__default.createElement(Flexbox, { align: "center", justify: "space" },
                React__default.createElement(H5, null, title),
                actions))),
        React__default.createElement(CardContent, { maxHeight: maxHeight, padding: "large", style: { flex: 1 } }, children)));
};

var PanelButton = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React__default.createElement(Button, __assign({ appearance: "outlined", color: "primary", size: "xsmall" }, props), children));
};

var PrivateRoute = function (props) {
    var children = props.children, fallback = props.fallback, _a = props.permissions, permissions = _a === void 0 ? [] : _a;
    var hasPermissions = usePermissions();
    if (!hasPermissions(permissions)) {
        return fallback ? React__default.createElement(React__default.Fragment, null, fallback) : null;
    }
    return React__default.createElement(React__default.Fragment, null, children);
};

var SelectModal = function (props) {
    var hasNext = props.hasNext, isLoadingNext = props.isLoadingNext, isSearching = props.isSearching, items = props.items, loadNext = props.loadNext, onClose = props.onClose, onSearch = props.onSearch, onSelect = props.onSelect, _a = props.selectButtonLabel, selectButtonLabel = _a === void 0 ? 'Välj' : _a, renderItem = props.renderItem, _b = props.title, title = _b === void 0 ? 'Välj' : _b;
    var _c = useState([]), selectedItems = _c[0], setSelectedItems = _c[1];
    var _d = useState(), search = _d[0]; _d[1];
    var debouncedSearch = useDebounce(search, 500);
    useEffect(function () {
        if (debouncedSearch !== undefined) {
            onSearch === null || onSearch === void 0 ? void 0 : onSearch(debouncedSearch);
        }
    }, [debouncedSearch, onSearch]);
    return (React__default.createElement(Modal, { onClose: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); }, style: { height: '60vh' } },
        React__default.createElement(ModalHeader, { onClose: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); } }, title),
        onSearch && (React__default.createElement(ModalHeader, null,
            React__default.createElement("div", { style: { flex: 1, paddingRight: '0.75rem', position: 'relative' } },
                React__default.createElement(Input, { display: "block", onChange: function (search) {
                        //setSearch(search)
                        onSearch(search);
                    }, placeholder: "Fritexts\u00F6k", type: "text" }),
                isSearching && (React__default.createElement(Icon, { icon: faSpinner, spin: isSearching, pulse: true, style: { position: 'absolute', right: '1.75rem', top: '50%', transform: 'translateY(-50%)' } }))))),
        React__default.createElement(ModalContent, null,
            React__default.createElement(Flexbox, { direction: "column", gap: "medium" },
                React__default.createElement(Flexbox, { direction: "column", gap: "xsmall" }, items &&
                    renderItem &&
                    items.map(function (item, index) { return (React__default.createElement(Fragment, { key: "item-" + index },
                        index > 0 && React__default.createElement(Divider, null),
                        React__default.createElement(Flexbox, { align: "center", direction: "row", gap: "small" },
                            React__default.createElement("div", { style: { flex: 1 } }, renderItem(item)),
                            React__default.createElement(Button, { color: "secondary", size: "small", onClick: function () {
                                    if (selectedItems.includes(item)) {
                                        setSelectedItems(selectedItems.filter(function (i) { return i !== item; }));
                                    }
                                    else {
                                        setSelectedItems(__spreadArrays(selectedItems, [item]));
                                    }
                                } }, selectedItems.includes(item) ? 'Ångra' : 'Välj')))); })),
                hasNext && (React__default.createElement("div", null,
                    React__default.createElement(Button, { disabled: isLoadingNext, onClick: function () { return loadNext(); } }, "Ladda fler"))))),
        React__default.createElement(ModalFooter, null,
            React__default.createElement(Flexbox, { align: "center", direction: "row", justify: "space", style: { flex: 1 } },
                React__default.createElement(Text, { appearance: "light" }, pluralize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " vald[|a]"], ["", " vald[|a]"])), selectedItems.length)),
                React__default.createElement(Button, { disabled: selectedItems.length === 0, onClick: function () {
                        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedItems);
                    } }, selectButtonLabel)))));
};
var templateObject_1;

var Sidebar = function (props) {
    var children = props.children;
    return (React__default.createElement(Flexbox, { direction: "column", gap: "large" }, React__default.Children.map(children, function (child, index) { return (React__default.createElement(Fragment, { key: index },
        index > 0 && React__default.createElement(Divider, null),
        child)); })));
};

var SidebarAction = function (props) {
    var children = props.children, disabled = props.disabled, onClick = props.onClick;
    return (React__default.createElement(Button, { appearance: "outlined", color: "primary", disabled: disabled, onClick: function () { return onClick(); }, size: "xsmall" }, children));
};

var SidebarMenu = function (props) {
    var children = props.children;
    return (React__default.createElement(Flexbox, { direction: "column", gap: "small" }, children));
};

var SidebarSection = function (props) {
    var actions = props.actions, children = props.children, title = props.title;
    return (React__default.createElement(Flexbox, { direction: "column", gap: "medium" },
        React__default.createElement(Flexbox, { direction: "row", gap: "small", justify: "space" },
            React__default.createElement(H5, null, title),
            actions),
        children));
};

var Toast = function (props) {
    var color = props.color, children = props.children, onDismiss = props.onDismiss;
    return (React__default.createElement(Notification, { color: color, onClose: function () { return onDismiss(); }, style: { zIndex: 2000 }, title: children }));
};

var ToastController = function (props) {
    var _a = useState(), timeoutItem = _a[0], setTimeoutItem = _a[1];
    useEffect(function () {
        var onDismiss = props.onDismiss, _a = props.autoDismissTimeout, autoDismissTimeout = _a === void 0 ? 5000 : _a;
        setTimeoutItem(new Timer(onDismiss, autoDismissTimeout));
    }, []);
    useEffect(function () {
        if (!timeoutItem)
            return;
        return function () { return timeoutItem.clear(); };
    }, [timeoutItem]);
    useEffect(function () {
        if (!timeoutItem)
            return;
        timeoutItem.pause();
        timeoutItem.resume(props.onDismiss);
    }, [props.onDismiss]);
    return React__default.createElement(Toast, __assign({}, props));
};

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var ToastProvider = function (props) {
    var children = props.children;
    var _a = useState([]), toasts = _a[0], setToasts = _a[1];
    var addToast = function (content, options) {
        var id = (options === null || options === void 0 ? void 0 : options.id) || createRandomId();
        setToasts(__spreadArrays(toasts, [__assign({ content: content, id: id }, options)]));
        return id;
    };
    var removeToast = function (id) {
        setToasts(toasts.filter(function (item) { return item.id !== id; }));
        return id;
    };
    var portalTarget = canUseDOM ? document.body : null;
    return (React__default.createElement(ToastContext.Provider, { value: { toasts: toasts, addToast: addToast, removeToast: removeToast } },
        children,
        portalTarget ? (createPortal(React__default.createElement(ToastContainer, null, toasts === null || toasts === void 0 ? void 0 : toasts.map(function (_a) {
            var content = _a.content, color = _a.color, id = _a.id;
            return (React__default.createElement(ToastController, { key: id, color: color || 'primary', onDismiss: function () { return removeToast(id); } }, content));
        })), portalTarget)) : (React__default.createElement(ToastContainer, null))));
};

var ThemeProvider = function (props) {
    var children = props.children, theme = props.theme;
    return (React__default.createElement(ThemeProvider$1, { theme: theme },
        React__default.createElement(ToastProvider, null,
            React__default.createElement(PortalProvider, null,
                children,
                React__default.createElement("div", { id: "popoverContainer", style: { zIndex: 1000000 } }),
                React__default.createElement("link", { href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap", rel: "stylesheet" }),
                React__default.createElement("link", { href: "https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap", rel: "stylesheet" }),
                React__default.createElement("style", { dangerouslySetInnerHTML: {
                        __html: "\n            /* http://meyerweb.com/eric/tools/css/reset/ \n              v2.0 | 20110126\n              License: none (public domain)\n            */\n\n            html, body, div, span, applet, object, iframe,\n            h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n            a, abbr, acronym, address, big, cite, code,\n            del, dfn, em, img, ins, kbd, q, s, samp,\n            small, strike, strong, sub, sup, tt, var,\n            b, u, i, center,\n            dl, dt, dd, ol, ul, li,\n            fieldset, form, label, legend,\n            table, caption, tbody, tfoot, thead, tr, th, td,\n            article, aside, canvas, details, embed, \n            figure, figcaption, footer, header, hgroup, \n            menu, nav, output, ruby, section, summary,\n            time, mark, audio, video {\n              margin: 0;\n              padding: 0;\n              border: 0;\n              font-size: 100%;\n              font: inherit;\n              vertical-align: baseline;\n            }\n            /* HTML5 display-role reset for older browsers */\n            article, aside, details, figcaption, figure, \n            footer, header, hgroup, menu, nav, section {\n              display: block;\n            }\n            body {\n              line-height: 1;\n            }\n            ol, ul {\n              list-style: none;\n            }\n            blockquote, q {\n              quotes: none;\n            }\n            blockquote:before, blockquote:after,\n            q:before, q:after {\n              content: '';\n              content: none;\n            }\n            table {\n              border-collapse: collapse;\n              border-spacing: 0;\n            }\n\n            /* Sonika */\n            html {\n              height: 100%;\n            }\n            \n            a {\n              color: #0C2AF3; /* TODO: Remove this CSS rule - links should be styled in component */\n              text-decoration: none;\n            }\n            \n            body {\n              background-color: #F8F9FA;\n              color: #131313;\n              height: 100%;\n              display: flex;\n              flex-grow: 1;\n              margin: 0;\n              -moz-osx-font-smoothing: grayscale;\n              -webkit-font-smoothing: antialiased;\n            }\n            \n            #root {\n              display: flex;\n              flex: 1;\n            }\n            \n            /* TODO: Required below? */\n            \n            input.hide-date-picker::-webkit-calendar-picker-indicator {\n              display: none;\n            }\n            \n            input.hide-date-picker::-webkit-inner-spin-button {\n              display: none;\n            }\n            \n            input.hide-date-picker::-webkit-clear-button {\n              display: none;\n            }\n            \n            body, button, input, textarea {\n              font-family: 'Inter', serif;\n            }\n\n            table {\n              page-break-inside:auto\n            }\n\n            tfoot {\n              display: table-footer-group\n            }\n\n            thead {\n              display: table-header-group\n            }\n\n            tr {\n              page-break-inside: avoid;\n              page-break-after: auto\n            }\n\n            *:focus {\n              outline: 0;\n            }\n            \n            strong {\n              font-weight: bold;\n            }\n          ",
                    } })))));
};

var SimpleSelect = function (props) {
    var children = props.children, error = props.error, _a = props.wrapperProps, wrapperProps = _a === void 0 ? {} : _a, _b = props.selectProps, selectProps = _b === void 0 ? {} : _b;
    var wrapperClassName = wrapperProps.className, restWrapperProps = __rest(wrapperProps, ["className"]);
    var selectClassname = selectProps.className, onBlur = selectProps.onBlur, restSelectProps = __rest(selectProps, ["className", "onBlur"]);
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    return (React__default.createElement("div", __assign({ className: ['simple-select', wrapperClassName].join(' ') }, restWrapperProps),
        React__default.createElement("select", __assign({}, restSelectProps, { onClick: function (event) {
                setIsOpen(!isOpen);
            }, onBlur: function (event) {
                setIsOpen(false);
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
            }, className: [selectClassname, (!!error ? 'has-error' : '')].join(' ') }), children),
        !!error && (React__default.createElement("div", { className: 'error-icon-container' },
            React__default.createElement(Tooltip, { content: error },
                React__default.createElement(Icon, { className: "error-icon", icon: faExclamationCircle })))),
        React__default.createElement("div", { className: "caret-icon-container" },
            React__default.createElement(Icon, { className: "caret-icon", icon: isOpen ? faCaretUp : faCaretDown }))));
};

export { Accordion, AccordionItem, Checkbox, ColorInput, ContextMenu, ContextMenuItem, CopyableText, DataTable, DateTimePicker, DrawerSkeleton, Form, FormModal, InlineColorSelect, InlineDateTimeInput, KeyValue, ListBox, ListBoxBody, ListBoxEmptyState, ListBoxFooter, ListBoxHeader, ListBoxItem, ListBoxSearch, MarkdownEditor, Menu, MenuItem, ModalSkeleton, ModalToSheet, ModalToSheetContent, ModalToSheetFooter, ModalToSheetHeader, ModalToSheetSkeleton, Panel, PanelButton, PopoverLink, PopoverToSheetFooter, PopoverToSheetHeader, PopoverToSheetSkeleton, PortalProvider, PrivateRoute, SelectModal, SheetSkeleton, Sidebar, SidebarAction, SidebarMenu, SidebarSection, SimpleSelect, TableBody, TableHead, TableRow, ThemeProvider };
//# sourceMappingURL=index.js.map
